// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restricted_modal {
  background: #e4e4e4;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.restricted_modal_section {
  width: 90%;
  max-width: 480px;
  margin: 100px auto;
  background: white;
  border-radius: 5px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
  overflow: hidden;
  animation: zoomIn 2s forwards;
  transition: all 2s;
  padding: 0;
  transform-origin: center center;
}
@keyframes zoomIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.title_restricted {
  font-family: sans-serif;
  padding: 15px;
  background: black;
  font-weight: 600;
  color: white;
  font-size: 20px;
  letter-spacing: 0.2px;
}
.redirection_section {
  padding: 10px;
}
button:hover {
  color: black !important;
  background: transparent;
}
p {
  font-size: 14px;
  font-weight: 700;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/RestrictedModal/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB;2EACyE;EACzE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".restricted_modal {\r\n  background: #e4e4e4;\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.restricted_modal_section {\r\n  width: 90%;\r\n  max-width: 480px;\r\n  margin: 100px auto;\r\n  background: white;\r\n  border-radius: 5px;\r\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,\r\n    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;\r\n  overflow: hidden;\r\n  animation: zoomIn 2s forwards;\r\n  transition: all 2s;\r\n  padding: 0;\r\n  transform-origin: center center;\r\n}\r\n@keyframes zoomIn {\r\n  0% {\r\n    transform: scale(0);\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    transform: scale(1.1);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.title_restricted {\r\n  font-family: sans-serif;\r\n  padding: 15px;\r\n  background: black;\r\n  font-weight: 600;\r\n  color: white;\r\n  font-size: 20px;\r\n  letter-spacing: 0.2px;\r\n}\r\n.redirection_section {\r\n  padding: 10px;\r\n}\r\nbutton:hover {\r\n  color: black !important;\r\n  background: transparent;\r\n}\r\np {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
